export default function WhatsAppFab() {
  const numero = "50685076464";
  const mensaje = "Hola, me interesa una batería para mi vehículo";
  const url = `https://wa.me/${numero}?text=${encodeURIComponent(mensaje)}`;

  return (
    <a href={url} target="_blank" rel="noreferrer"
      className="fixed bottom-24 right-7 z-50 bg-green-500 text-white px-5 py-3 rounded-full font-bold text-sm flex items-center gap-2 shadow-lg hover:scale-105 transition-transform">
      💬 WhatsApp
    </a>
  );
}
